import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
var cache = setupCache({
  maxAge: 3 * 60 * 1000
}); // Create `axios` instance passing the newly created `cache.adapter`

var api = axios.create({
  adapter: cache.adapter
});
export default api;